import { render, staticRenderFns } from "./ReadingPageView.vue?vue&type=template&id=07c61475&scoped=true"
import script from "./ReadingPageView.vue?vue&type=script&lang=js"
export * from "./ReadingPageView.vue?vue&type=script&lang=js"
import style0 from "./ReadingPageView.vue?vue&type=style&index=0&id=07c61475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c61475",
  null
  
)

export default component.exports